import React, {Component} from 'react';
import {RESPONSE, API_BASE_URL,CREDIT_NOTICE,USERDATA} from '../../resources/constant';
import {getDBAName,getListOfCreditNoticeMerchant,viewCreditReport} from '../../Utilities/WSUtil';
import {retentionYears, allMonths, allDays, zeroPad} from '../../Utilities/DatePicker';
import {Link} from 'react-router-dom';
import {Row,Col,Form, Modal} from 'react-bootstrap';
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn,FakeBtn} from '../../theme/MorsTheme';
import renderHTML from 'react-render-html';
import MerchantPicker from '../../Utilities/MerchantPicker';
import axios from 'axios';
export default class SearchMerchantReport extends Component{
    constructor(props){
        super(props);        
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.blurChange = this.blurChange.bind(this);
        //Monina start - added
        this.updateFromAllDays = this.updateFromAllDays.bind(this);
        //Monina end - added
        this.state = {       
            cu:JSON.parse(localStorage.getItem(RESPONSE)), 
            url:API_BASE_URL+'cad/merchant/getMerchCreditNotice?',       
            checkedAllReport:false, 
            searchSingleId: '',
            //fromDay:'01',
            //fromMonth:'01',
            //fromYear:'2024',
            btnShow: false,
            btnShow2: false,                        
            fetchMessage:'',
            names:[],
            loading: false,
            fromAllDays: allDays, //Monina added   
	        merchList:[],
            submitHide:'true',
            verifiedMID:false
                                 
        };
    }      
    
   //Monina start - added
   updateToAllDays(e){
    var toYear = document.getElementById('toYear').value;
    var toMonth = document.getElementById('toMonth').value;
    var valYear = (typeof toYear !== 'undefined') ? toYear : 0;
    var valMonth = (typeof toMonth !== 'undefined') ? toMonth : 0;
    this.setState({
        [e.target.id]: e.target.value, 
        toAllDays: this.updateAllDays(valYear, valMonth)});
    }

    showMerchantPicker(){
        
    }

    selectMerchantPicker = (mer) =>{
        this.setState({
            fetchMessage:'',
            searchSingleId: mer.id,
            names:{ legalName: mer.corpName, 
                    corpName: mer.dbaName}
        })
    }



    isInputValid(){        
        if(this.state.searchSingleId === '' && this.state.checkedAllReport === false){                        
            alert('Merchant ID cannot be null')            
            return false;
        }
        
        if(this.state.fetchMessage!=='' && this.state.searchSingleId !== '' ){
            if(this.state.checkedAllReport === false){
                alert('Please input a valid Merchant ID.');            
                return false;
            }
        }

        return true;
    }
    componentWillMount(){
        this.setState({
            btnShow: this.state.cu.user.allReportAccess,
            btnShow2: this.state.cu.user.allReportAccess,
            names:{legalName: '', corpName: ''},
            fetchMessage:''
        })
    }
    
    toggleChange = () => {        
        this.setState({
            checkedAllReport: !this.state.checkedAllReport,
            searchSingleId:'',
            names:{legalName: '', corpName: ''},
            submitHide:!this.state.submitHide,
            btnShow2: !this.state.btnShow2
        
        });
      }

    //Monina start - added
    updateFromAllDays(e){
        var fromYear = document.getElementById('fromYear').value;
        var fromMonth = document.getElementById('fromMonth').value;
        var valYear = (typeof fromYear !== 'undefined') ? fromYear : 0;
        var valMonth = (typeof fromMonth !== 'undefined') ? fromMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            fromAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateAllDays(year, month){
        var selDate = new Date(year, month, 0);
        var arrResult = [];
        Array.from(Array(selDate.getDate())).map((e,i)=>i+1).forEach(function(value, idx){
            arrResult[idx+1] = value;
        });
        return arrResult;
    }
    //Monina end - added
        
    handleChange(e){
        this.setState(
            {                
                [e.target.id]: e.target.value   
            }
        )
    }

    viewReport(){
       
        if(this.isInputValid()){
            var uploadDate =
            document.getElementById('fromMonth').value  + "/" +
            document.getElementById('fromDay').value    + "/" +
            document.getElementById('fromYear').value;
            
            // alert(this.state.searchSingleId +" "+uploadDate);
            // window.open(API_BASE_URL+"cad/merchant/getMerchCreditNotice?merchId="+this.state.searchSingleId+"&upldDate="+uploadDate+".pdf","_blank")
            this.props.getCreditReports(this.state.searchSingleId,uploadDate)
        }
    }
    
    blurChange(e){
        e.preventDefault();
        if(this.state.searchSingleId !== ""){
            // this.setState({loading: true});                
            getDBAName(this.state.cu.user.userId, this.state.searchSingleId).then(response =>             
                ({
                    legalName: `${response.dbaName}`,
                    corpName: `${response.corpName}`
                })                                                
            ).then(names => this.setState({names,fetchMessage:'',verifiedMID: true}))                
            .catch(error =>{            
                this.setState({
                    fetchMessage: 
                    `Sorry, the Merchant lD you're searching for does not exist in our system. <br/>
                    Please check the details you selected and try again. `,
                    names:{legalName: '', corpName: ''},
                    loading: false,
                    verifiedMID:false
                })                                             
            })
        }      
    }
   
    handleSubmit(event) {
        event.preventDefault();      
        
        if(this.isInputValid()){
        // window.open(`${this.state.url}merchId=${this.state.searchSingleId}&upldDate=${this.state.fromMonth}/${this.state.fromDay}/${this.state.fromYear}`, "_blank");
        

        var uploadDate =   
        document.getElementById('fromYear').value+
        document.getElementById('fromMonth').value+
        document.getElementById('fromDay').value;
        
        var uploadDate2 =
        
        document.getElementById('fromMonth').value  + "/" +
        document.getElementById('fromDay').value    + "/" +
        document.getElementById('fromYear').value;

        if(this.state.searchSingleId === '' && this.state.checkedAllReport === false){
           alert('Please input MerchantID');                     
        }
        else if(this.state.searchSingleId !== '' ){
             //window.open(`${this.state.url}merchId=${this.state.searchSingleId}&upldDate=${this.state.fromMonth}/${this.state.fromDay}/${this.state.fromYear}`, "_blank");
            // this.props.getCreditReports()
            //alert('single id search');

            var mid = this.state.searchSingleId;
            var uploadDate = this.state.fromMonth + "/" + this.state.fromDay + "/" + this.state.fromYear;

            //viewCreditReport(mid, uploadDate)

            //alert("uploadDate2 = " + uploadDate2);
            axios(this.state.url + "merchId="+mid+"&upldDate="+uploadDate2, {
                headers: {'Authorization': `Bearer ${localStorage.getItem('accessToken')}`},
                method: "GET",
                responseType: "blob"

            }).then(response => {                
              
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    //IE11 and the legacy version Edge support
                    console.log("IE & Edge");
                    let blob = new Blob([response.data], { type: "text/html" });
                    window.navigator.msSaveOrOpenBlob(blob, "CN.pdf");
                } else {// other browsers
                    console.log("response data = " + response.data);
                    const file = new Blob([response.data], { type: "application/pdf" });
                    console.log("file = " + file);    
                    //Build a URL from the file
                    const fileURL = URL.createObjectURL(file);
                    console.log("fileURL = " + fileURL);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                }
                
             }).catch(error =>{ 
                //console.log("err: "+JSON.stringify(error))
                console.log(error);
                this.setState({
                    fetchMessage: 'Sorry, there is/are no recorded transaction/s for the date you selected.'
                })                                     
            }) ;
        }
        else{
            var x = JSON.parse(localStorage.getItem(USERDATA));
            
            getListOfCreditNoticeMerchant(                      
                x.userId,
                x.allReportAccess,
                uploadDate
            ).then(response => {                
                this.props.getTypeReport("");
                this.props.getMerchList(response,uploadDate2);            
             }).catch(error =>{ 
                 //console.log("err: "+JSON.stringify(error))
                this.setState({
                    fetchMessage: 'Sorry, there is/are no recorded transaction/s for the date you selected.'
                })                                     
            }) 
        }    
        
        }
    }

    render(){                       
        const {legalName, corpName} = this.state.names;                      
        return(                               
	    <div>
            <BodyHeaderDiv>
                    <BodyHeaderText>Merchant Credit Notice</BodyHeaderText>
            </BodyHeaderDiv>
            <ContentDiv>
            <Row>

                <Col>
                    <Row>
                        <Col>
                        <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}} >
                        {renderHTML(this.state.fetchMessage)}
                        </span>
                        </Col>
                    </Row>
                    <Row>
                    <Col md={3}></Col>                
                    <Col md={6}>
                    <Form onSubmit={this.handleSubmit}>                          
                    <Form.Label size='sm' style={{fontWeight:'bold'}}>View Report for one (1) Merchant ID</Form.Label>
                    <Form.Row>                        
                        <Form.Group as ={Col} sm={this.state.btnShow?12:10} controlId="searchSingleId" onChange={this.handleChange} onBlur={this.blurChange}>                                                
                            <Form.Control maxLength={10} size='sm' type="text" value={this.state.searchSingleId} disabled={this.state.checkedAllReport}></Form.Control>                                                                            
                        </Form.Group >        
                        <Form.Group as={Col} sm={1} hidden={this.state.btnShow}>                            
                            {/* <Link to='/merchSearchRep' onClick={this.showMerchantPicker}><MidCifBtn>...</MidCifBtn></Link> */}
                            <Form.Group  as={Col} xs={this.state.btnShow2?0:1}  hidden={this.state.btnShow2}>
                                <MerchantPicker userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                            </Form.Group>
                        </Form.Group>                                                                                        
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="legalName" onChange={this.handleChange}>
                            <Form.Label size='sm' style={{fontWeight:'bold'}}>Legal Name</Form.Label>
                            <Form.Control type="text" value={legalName} size='sm' disabled></Form.Control>
                        </Form.Group>
                    </Form.Row>

                    <Form.Label size='sm' style={{fontWeight:'bold'}}>DBA Name</Form.Label>
                    <Form.Row>
                        <Form.Group as={Col} sm={this.state.btnShow?12:10} controlId="dbaName" onChange={this.handleChange}>                            
                            <Form.Control type="text" value={corpName} size='sm' disabled></Form.Control>                            
                        </Form.Group>
                        <Form.Group as={Col} hidden={this.state.btnShow}>
                            <Form.Group  as={Col} xs={this.state.btnShow2?0:1}  hidden={this.state.btnShow2}>
                                <MerchantPicker userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                            </Form.Group>
                        </Form.Group> 
                    </Form.Row>



                    <Form.Label size='sm' style={{fontWeight:'bold'}}>Payment Date</Form.Label>
                    <Form.Row>                                                
                        <Form.Group as={Col} controlId="fromMonth" onChange={this.updateToAllDays} onBlur={this.blurChange}>                                                            
                            <Form.Control as="select" size='sm' value={this.state.fromMonth}>
                            {   allMonths.map((option, index) =>                             
                                <option key={index} value={option.id}>{option.month}</option> )  
                            }                              
                            </Form.Control>                                                                
                        </Form.Group>
                        <Form.Group as={Col} controlId="fromDay" onChange={this.handleChange}>                                                                                            
                            <Form.Control as="select" size='sm' value={this.state.fromDay}>
                            {   this.state.fromAllDays.map((option, index) =>                                 
                                <option key={index} value={zeroPad(option,2)}>{option}</option>)
                            }                             
                            </Form.Control>                                                                
                        </Form.Group>
                        <Form.Group as={Col} controlId="fromYear" onChange={this.updateToAllDays}>                                                                                            
                            <Form.Control as="select" size='sm' value={this.state.fromYear}>
                            {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                                                                              
                                <option key={index} value={option}>{option}</option>)
                            }                            
                            </Form.Control>                                                                
                        </Form.Group>                                                         
                    </Form.Row>                                        
                    <Form.Row>
                        <Form.Group as={Col} controlId="checkedAllReport" onChange={this.toggleChange}>
                            <Form.Check size='lg' label='View All Reports for Multiple Merchant IDs'  style={{fontWeight:'bold'}}/>                                                                                                                                            
                        </Form.Group>
                    </Form.Row>                             
                    <div align="center">
                    
                     
                    
                    <SubmitBtn style={{color:'#FFFFFF'}}>
                        View Reports
                    </SubmitBtn> 
                    </div>

                </Form>  
                    </Col>
                    <Col md={3}>
                    </Col>


                    </Row>
                </Col>
                
                </Row>
                </ContentDiv>       
                <Modal show={this.state.loading} backdrop={'static'}  centered={true} backdropClassName='fade' dialogClassName="modal-bdox">  
                    <div>
                        <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader>                
                    </div>                                  
                </Modal>        
            </div>

        )
    }
}


